import React from 'react';
import { Button, Typography, Box } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { downloadResume } from '../candidateManagementApi';
import { useParams } from 'react-router-dom';
import { useSnackbar } from '../../../../Context/SnackbarContext';

type Props = {
  candidateMapID: number;
};

const ViewResumeButton: React.FC<Props> = ({ candidateMapID }) => {
    const { tenant } = useParams<{ tenant: string }>();
    const { showSnackbar } = useSnackbar();

    const handleDownloadResume = async () => {
        try {
          const response = await downloadResume(tenant, { CandidateJobMapID: candidateMapID });

          if (!response) {
            showSnackbar("No response received while downloading resume.", "error");
            return;
          }
      
          if (response.data.type === 'application/json') {
            const text = await response.data.text(); // error blob as text
            const errorData = JSON.parse(text);
            showSnackbar(errorData.Message || "Failed to download resume", "error");
            return;
          }
      
          const blob = response.data;
      
          // Try to extract filename from headers
          const disposition = response.headers['content-disposition'] || response.headers['Content-Disposition'];
          console.log("Content-Disposition:", disposition);
          let filename = 'resume.pdf'; // fallback
      
          if (disposition && disposition.includes('filename=')) {
            const match = disposition.match(/filename="?([^";]+)"?/);
            if (match?.[1]) filename = match[1];
          }
      
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
      
        } catch (err) {
          console.error("Download error:", err);
          showSnackbar("Something went wrong while downloading the resume.", "error");
        }
      };
      

  return (
    <Box display="flex" flexDirection="column" gap={1} mb='1.6vw' >
      <Typography variant="subtitle2" fontWeight={600} color="text.primary">
        Resume
      </Typography>
      <Button
        variant="contained"
        startIcon={<PictureAsPdfIcon />}
        onClick={() => handleDownloadResume()}
        sx={{
          backgroundColor: '#f3f4f6',
          color: '#8b5cf6',
          fontWeight: 600,
          textTransform: 'none',
          borderRadius: '8px',
          width: 'fit-content',
          px: 2.5,
          ml:1,
          '&:hover': {
            backgroundColor: '#e5e7eb',
          },
        }}
      >
        View Resume (PDF)
      </Button>
    </Box>
  );
};

export default ViewResumeButton;
